import { useAppForm } from '~/shared/lib/form'

export interface CodeGroupFormValues {
  key: string | null
  carcs: string[]
  rarcs: string[]
  payorSpecificCodes: string[]
  /** Per-code amount. Cents when parent deduction is 'cents'; raw percentage when 'percentage'. */
  amount: number | null
}

export type AmountType = 'cents' | 'percentage'

export interface DeductionFormValues {
  amount: number | null
  amountType: AmountType
  codeGroups: CodeGroupFormValues[]
}

export interface ServiceLineFormValues {
  serviceLineId: string | null
  serviceDate: string
  cptCode: string
  billedAmount: number | null
  allowedAmount: number | null
  discount: number | null
  otherPlan: number | null
  adjustments: DeductionFormValues
  deductible: DeductionFormValues
  coInsurance: DeductionFormValues
  copayment: DeductionFormValues
  nonCovered: DeductionFormValues
}

export interface PatientClaimFormValues {
  patientAccountNumber: string
  totalPaid: number | null
  patientFirstName: string
  patientLastName: string
  patientDob: string
  claimNumber: string
  memberId: string
  pageOfDoc: string
  localFlag: { notes: string } | null
  serviceLines: ServiceLineFormValues[]
}

export type PatientClaimFormApi = ReturnType<typeof _inferFormType>
function _inferFormType() {
  // This function is never called at runtime. It exists solely for type inference.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useAppForm({ defaultValues: {} as PatientClaimFormValues })
}

const emptyDeduction: DeductionFormValues = {
  amount: null,
  amountType: 'cents',
  codeGroups: [],
}

export function createEmptyServiceLine(): ServiceLineFormValues {
  return {
    serviceLineId: null,
    serviceDate: '',
    cptCode: '',
    billedAmount: null,
    allowedAmount: null,
    discount: null,
    otherPlan: null,
    adjustments: { ...emptyDeduction },
    deductible: { ...emptyDeduction },
    coInsurance: { ...emptyDeduction },
    copayment: { ...emptyDeduction },
    nonCovered: { ...emptyDeduction },
  }
}
